import { useTranslation } from 'react-i18next';
import { GridColumn } from 'src/components/GridWrapper';
import { CenterHeaderCell } from 'src/components/custom-headers/CenterHeaderCell';
import { UseClosePeriodPermissions } from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import useViewCalendarYear from 'src/hooks/useViewCalendarYear';
import LineItemInfo from 'src/sections/invoice_details/lineItemsColumns/LineItemInfo';
import DeletePeriod from 'src/sections/view_periods/view_periods_cell/DeletePeriod';
import EndDate from 'src/sections/view_periods/view_periods_cell/EndDate';
import Period from 'src/sections/view_periods/view_periods_cell/Period';
import StartDate from 'src/sections/view_periods/view_periods_cell/StartDate';
import Status from 'src/sections/view_periods/view_periods_cell/Status';

const usePeriodsTableColumns = () => {
  const { t } = useTranslation();
  const { isPeriodEditMode } = useViewCalendarYear();
  const usePeriods = usePermission({ permissions: UseClosePeriodPermissions });

  const columns: GridColumn<any>[] = [
    {
      field: 'dataIndex',
      title: '#',
      width: 60,
      menu: false,
      sortable: false,
      dataType: 'fixed',
      component: Period,
      headerCell: CenterHeaderCell,
    },
    ...(isPeriodEditMode
      ? ([
          {
            field: 'errors',
            title: '',
            width: 40,
            component: LineItemInfo,
            menu: false,
            sortable: false,
          },
        ] as const)
      : []),
    {
      field: 'startDate',
      title: t('Start Date'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
      component: StartDate,
    },
    {
      field: 'endDate',
      title: t('End Date'),
      menu: false,
      sortable: false,
      dataType: 'fixed',
      headerCell: CenterHeaderCell,
      component: EndDate,
    },
    ...(usePeriods
      ? ([
          {
            field: 'isClosed',
            title: 'Status',
            menu: false,
            dataType: 'fixed',
            headerCell: CenterHeaderCell,
            component: Status,
          },
        ] as const)
      : []),

    ...(isPeriodEditMode
      ? ([
          {
            field: 'canDeletePeriod',
            title: '',
            width: 100,
            component: DeletePeriod,
            menu: false,
            sortable: false,
          },
        ] as const)
      : []),
  ];
  return columns;
};

export default usePeriodsTableColumns;
